import React from 'react';
import { Icon, Button, Select, MenuItem, CircularProgress, Switch, FormGroup, FormControlLabel } from '@material-ui/core';
import { filterStyles } from './styles';
import { get } from 'global/lib/lodash';
import clsx from 'clsx';
import ScorecardToggle from './ScorecardToggle';
import SearchBar from 'global/components/SearchBar';
import { removeOverflowFromBody } from 'global/utils';

export default (props) => {
  const { selected, setFilter, buttons, changeSearch, searchString, loading } = props;
  const classes = filterStyles();
  const selVal = get(selected, 'value');

  return (
    <div className={classes.container}>
      <ScorecardToggle {...props} />
      <div className={classes.wrapper}>
        <SearchBar
          onClear={() => {
            changeSearch('');
          }}
          changeSearch={changeSearch}
          searchString={searchString}
          classes={classes.searchContainer}
        />
        <div className={classes.buttonMargin}>{loading ? <CircularProgress size={24} /> : <Icon>filter_list</Icon>}</div>
        {buttons.map((button, i) => {
          const type = get(button, 'type', 'default');
          if (type === 'select') {
            const selectSelected = button.options.find((o) => o.val === get(selected, button.val));
            return (
              <Select
                key={button.val}
                value={get(selectSelected, 'val')}
                variant="filled"
                defaultValue="N/A"
                className={classes.select}
                disableUnderline
                onChange={(e) => setFilter((f) => ({ ...f, [button.val]: e.target.value }))}
                onClose={() => removeOverflowFromBody()}
              >
                {button.options.map((opt, i) => {
                  return (
                    <MenuItem key={i} value={get(opt, 'val')}>
                      {opt.text}
                    </MenuItem>
                  );
                })}
              </Select>
            );
          } else if (type === 'switch') {
            const on = !!get(props, button.val);
            return (
              <div key={button.val} className={classes.switchContainer}>
                <FormGroup row className={classes.center}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={on}
                        onChange={(e) => button.onChange(e.target.checked)}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        disabled={button.disabled ? button.disabled(props) : false}
                      />
                    }
                    label={get(button, ['text', on ? 'on' : 'off'], get(button, 'text'))}
                  />
                </FormGroup>
              </div>
            );
          }

          const isSelected = selVal === get(button, 'val');
          return (
            <Button
              key={i}
              className={classes.buttonMargin}
              size={'small'}
              onClick={() => setFilter((f) => ({ ...f, value: button.val }))}
              variant="contained"
              color={isSelected ? 'primary' : undefined}
              disableElevation
            >
              {button.text}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
